import create from "zustand";
import { PaymentOption } from "~features/checkout/common/checkout.types";
import { logger } from "~features/seated-reservation/store/middleware";

export type Store = {
  paymentOptions: PaymentOption[];
  selectedPaymentOption?: PaymentOption;
  paymentPlanFeeAmount?: number;
};

const initialState: Store = {
  paymentOptions: [],
  selectedPaymentOption: undefined,
};

export const usePaymentOptionsStore = create<Store>(
  logger(
    (set, get) => ({
      ...initialState,
    }),
    "payment-options-store"
  )
);

export const resetState = () =>
  usePaymentOptionsStore.setState(initialState, true);
